import { motion } from "framer-motion";
import React, { memo, useMemo } from "react";
import { useFiltro } from "../../../../../../contexts/FiltroContext.tsx";
import IconButton from "../../../../../../core/components/IconButton.tsx";
import Separator from "../../../../../../core/components/Separator.tsx";
import BarraSearch from "../../../../../../core/data-entry/BarraSearch.tsx";
import FiltroData from "../../../../../../core/data-entry/FiltroData.tsx";
import { SHADOWS } from "../../../../../../core/shadows.ts";
import { formatDate } from "../../../../../../core/utils/formatDate.ts";
import { FiltroEmbarqueCompletoEnum } from "../../../../../../models/FiltroEmbarqueCompleto.ts";

export interface ModalFiltroViagensHeaderProps {
	onClose: () => void;
	isScrolled: boolean;
	buscarViagens: () => void;
}

function ModalFiltroViagensHeader({
	onClose,
	isScrolled,
	buscarViagens,
}: ModalFiltroViagensHeaderProps) {
	const { filtroEmbarque, setFiltro } = useFiltro();

	const valuePrevisaoEmbarqueInicio = useMemo(() => {
		const date = new Date();
		return (
			formatDate(filtroEmbarque.previsaoEmbarqueInicio) ||
			new Date(date.getFullYear(), date.getMonth(), 1)
				.toISOString()
				.split("T")[0]
		);
	}, [filtroEmbarque.previsaoEmbarqueInicio]);

	const valuePrevisaoEmbarqueFim = useMemo(() => {
		const date = new Date();
		return (
			formatDate(filtroEmbarque.previsaoEmbarqueFim) ||
			new Date(date.getFullYear(), date.getMonth() + 1, 0)
				.toISOString()
				.split("T")[0]
		);
	}, [filtroEmbarque.previsaoEmbarqueFim]);

	return (
		<motion.div
			className="modal-filtros-viagens-header"
			animate={{
				boxShadow: isScrolled ? SHADOWS.lg.boxShadow : "none",
			}}
			transition={{ duration: 0.3 }}
		>
			<div className="filtro-data-container">
				<FiltroData
					title="Início"
					value={valuePrevisaoEmbarqueInicio}
					onChange={(value) =>
						setFiltro(
							FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueInicio,
							formatDate(value)
						)
					}
				/>
				<div className="filtro-data-divider" />
				<FiltroData
					title="Fim"
					titleFrente={false}
					value={valuePrevisaoEmbarqueFim}
					onChange={(value) =>
						setFiltro(
							FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueFim,
							formatDate(value)
						)
					}
				/>
			</div>
			<Separator size="md" direction="horizontal" />
			<BarraSearch
				buscarSearch={buscarViagens}
				value={filtroEmbarque.valorGeral || ""}
				onChange={(e) => {
					setFiltro(FiltroEmbarqueCompletoEnum.ValorGeral, e);
				}}
			/>
			<Separator size="md" direction="horizontal" />
			<div
				style={{
					width: "200px",
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<motion.div
					initial={{ rotate: 0 }}
					whileHover={{ rotate: 90 }}
					transition={{ duration: 0.2, ease: "easeInOut" }}
				>
					<IconButton
						icon="X"
						size="xl"
						theme="light"
						backgroundColor="#FF0000"
						hoverColor="#640A0A"
						onClick={onClose}
					/>
				</motion.div>
			</div>
		</motion.div>
	);
}

export default memo(ModalFiltroViagensHeader);
